<template>
  <div class="homepage">
    <PreviewSlider></PreviewSlider>
    <div class="about">
      <div class="about__padding">
        <p class="heading-secondary-main pt-1">О продукте</p>
        <div class="about__wrapper">
          <div class="about__content">
            <p class="paragraph">
              <span class="bold">FCB VISUAL ANALYTICS</span> - уникальный в
              Казахстане модуль визуальной аналитики по кредитному рынку.
            </p>
            <img
              src="../../assets/illustrations/about-large.svg"
              alt=""
              class="about__illust"
            />
          </div>
          <div class="about__card card__list">
            <div class="card__item card__item--1">
              <!-- <div class="card__icon-wrapper">
                <img src="../../assets/icons/about-1.svg" alt="" class="card__icon">
              </div> -->
              <div class="card__content">
                <p>
                  <strong>Продвинутая аналитика</strong> от Аналитического
                  центра Первого Кредитного Бюро
                </p>
              </div>
            </div>
            <div class="card__item card__item--2">
              <!-- <div class="card__icon-wrapper">
                <img src="../../assets/icons/about-2.svg" alt="" class="card__icon">
              </div> -->
              <div class="card__content">
                <p>
                  Более <strong>50</strong> типов
                  <strong>отчетов</strong> розничного и бизнес-кредитования
                </p>
              </div>
            </div>
            <div class="card__item card__item--3">
              <!-- <div class="card__icon-wrapper">
                <img src="../../assets/icons/about-3.svg" alt="" class="card__icon">
              </div> -->
              <div class="card__content">
                <p>Удобные пакеты и гибкие цены</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PreviewSlider from "@/views/auth/components/PreviewSlider.vue";
import { mapState } from "vuex";
export default {
  components: {
    PreviewSlider,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.auth.isLoading,
      isLoggedIn: (state) => state.auth.isLoggedIn,
      validationErrors: (state) => state.auth.error,
      isAuthMobileForm: (state) => state.auth.isAuthMobileForm,
      isShowMobileMenu: (state) => state.auth.isShowMobileMenu,
    }),
    progressBarWidth() {
      return { width: Math.ceil(33.3 * this.currentSlider) + "%" };
    },
  },
  watch: {
    auth: {
      handler() {
        this.authErrorMessage = "";
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.homepage {
  @media (max-width: 650px) {
    margin-top: 13rem;
  }
}
.about {
  background-color: #f4fbff;
  width: 100%;
  &__padding {
    width: 100%;
    max-width: 1110px;
    margin: auto;
    padding: 0 45px 14rem;
  }
  &__wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
  }
  &__card {
    flex-basis: 47%;
  }
  &__content {
    flex-basis: 47%;
    display: flex;
    flex-direction: column;
  }
  &__illust {
    margin-top: 6rem;
    margin-left: auto;
    align-self: flex-end;
    max-width: 374px;
    width: 100%;
  }

  @media only all and (max-width: 900px) {
    &__wrapper {
      display: block;
    }
    &__illust {
      margin: auto;
    }
    &__card {
      margin-top: 80px;
    }
  }
  @media (max-width: 650px) {
    &__padding {
      padding: 0 15px 14rem;
    }
  }
}
.card {
  &__item {
    background: #ffffff;
    border: 1px solid #cce9ff;
    box-sizing: border-box;
    box-shadow: 0 4px 4px rgba(70, 173, 244, 0.1);
    border-radius: 3rem;
    //height: 8.3rem;
    min-height: 83px;
    padding-left: 13rem;
    &:not(:last-child) {
      margin-bottom: 1rem;
    }
    &--1 {
      position: relative;
      &::before {
        content: "";
        box-shadow: 0 4px 4px rgba(70, 173, 244, 0.1);
        border-radius: 30px 0 0 30px;
        background-size: initial;
        background: #0082be url(../../assets/icons/about-1.svg) no-repeat center;
        left: 0;
        width: 11rem;
        height: 100%;
        position: absolute;
      }
    }
    &--2 {
      position: relative;
      &::before {
        content: "";
        box-shadow: 0 4px 4px rgba(70, 173, 244, 0.1);
        border-radius: 30px 0 0 30px;
        background-size: initial;
        background: #0082be url(../../assets/icons/about-2.svg) no-repeat center;
        left: 0;
        width: 11rem;
        height: 100%;
        position: absolute;
      }
    }
    &--3 {
      position: relative;
      &::before {
        content: "";
        box-shadow: 0 4px 4px rgba(70, 173, 244, 0.1);
        border-radius: 30px 0 0 30px;
        background-size: initial;
        background: #0082be url(../../assets/icons/about-3.svg) no-repeat center;
        left: 0;
        width: 11rem;
        height: 100%;
        position: absolute;
      }
    }
  }
  &__content {
    display: flex;
    height: 121px;
    padding: 13px 13px 13px 0;
    align-items: center;
  }
  &:not(:last-child) {
    margin-bottom: 1rem;
  }
  @media (max-width: 650px) {
    &__item {
      min-height: 125px;
    }
  }
}
</style>
